import React, { useMemo, useState } from "react";
import { Box, Typography } from "@mui/material";

import DashBoardTable from "./reuseable-components/DashBoardTable";

const VotersTab = ({ voters = [] }) => {
  const [sortConfig, setSortConfig] = useState({
    key: "lastName",
    direction: "asc",
  });
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const columns = [
    { id: "name", label: "Name", sortable: true },
    { id: "address", label: "Address", sortable: true },
    { id: "phone", label: "Phone", sortable: true },
    { id: "email", label: "Email", sortable: true },
    { id: "party", label: "Party", sortable: true },
    { id: "district", label: "District", sortable: true },
    { id: "status", label: "Status", sortable: true },
    { id: "supportLevel", label: "Support", sortable: true },
  ];

  const rows = useMemo(
    () =>
      voters.map((voter) => ({
        name:
          [voter.firstName, voter.lastName].filter(Boolean).join(" ") || "-",
        firstName: voter.firstName || "",
        lastName: voter.lastName || "",
        address:
          [voter.address, voter.city, voter.state, voter.zipCode]
            .filter(Boolean)
            .join(", ") || "-",
        phone: voter.phone || "-",
        email: voter.email || "-",
        party: voter.party || "-",
        district: voter.district || "-",
        status: voter.status || "-",
        supportLevel: voter.supportLevel || "-",
      })),
    [voters],
  );

  const sortedRows = useMemo(() => {
    const data = [...rows];

    if (sortConfig.key) {
      data.sort((a, b) => {
        const valueA = a[sortConfig.key] || "";
        const valueB = b[sortConfig.key] || "";

        if (valueA < valueB) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }

        if (valueA > valueB) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }

        return 0;
      });
    }

    return data;
  }, [rows, sortConfig]);

  const paginatedRows = useMemo(() => {
    const start = (page - 1) * rowsPerPage;

    return sortedRows.slice(start, start + rowsPerPage);
  }, [page, rowsPerPage, sortedRows]);

  return (
    <Box
      sx={{
        bgcolor: "#fff",
        p: {
          xs: 1,
          md: 3,
        },
      }}
    >
      <Typography
        variant="h6"
        sx={{ fontWeight: 700, color: "#0F1E3D", mb: 3 }}
      >
        Voters
      </Typography>

      <DashBoardTable
        columns={columns}
        rows={paginatedRows}
        sortConfig={sortConfig}
        onSort={(key) =>
          setSortConfig({
            key,
            direction:
              sortConfig.key === key && sortConfig.direction === "asc"
                ? "desc"
                : "asc",
          })
        }
        page={page}
        totalPages={Math.ceil(sortedRows.length / rowsPerPage)}
        onPageChange={setPage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(value) => {
          setRowsPerPage(value);
          setPage(1);
        }}
        totalResults={sortedRows.length}
      />
    </Box>
  );
};

export default VotersTab;
